import { memo } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import ROUTES from '../assets/routes'
import PageWrapperPrimary from './pageWrapperPrimary'

type PageWrapperProps = {
    children: React.ReactNode
}

/** Screener and Heatmap have no primary-security tab title / WS — skip hooks so ticks do not re-render. */
function PageWrapper({ children }: PageWrapperProps) {
    const { pathname } = useLocation()
    if (matchPath(ROUTES.screener, pathname) || matchPath(ROUTES.heatmap, pathname)) {
        return <>{children}</>
    }
    return <PageWrapperPrimary>{children}</PageWrapperPrimary>
}

export default memo(PageWrapper)
